import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Input, Select, Box, Grid, GridItem, Button, useToast, Checkbox } from '@chakra-ui/react';
import * as Yup from 'yup';
import DatePicker from 'components/datePicker/DatePicker';
import xhr from 'xhr';
import dayjs from 'dayjs';
import { useSearchParams } from 'react-router-dom';
import SharedClassPicker from './SharedClassPicker';

export default function FormLiveClasses(props) {
  let [searchParams] = useSearchParams();
  const { semester, setReload, live, setIsOpen, title, user } = props;
  const [loading, setLoading] = React.useState(false);
  const [dateFilter, setDateFilter] = React.useState(null);
  const toast = useToast();

  // Clase compartida con otros programas (grados o carreras técnicas).
  const canShare = !user?.school && ['grade', 'technical_career'].includes(searchParams.get('type'));
  const initialSubjects = (live?.other_subjects || []).map((el) => el.id);
  const initialGroups = (live?.other_class_groups || []).map((el) => el.id);
  const [sharedEnabled, setSharedEnabled] = React.useState(initialSubjects.length > 0);
  const [otherSubjects, setOtherSubjects] = React.useState(initialSubjects);
  const [otherClassGroups, setOtherClassGroups] = React.useState(initialGroups);
  const [sharedValid, setSharedValid] = React.useState(true);

  // El mismo formulario se reutiliza al abrir otra clase: resincronizar.
  React.useEffect(() => {
    setSharedEnabled(initialSubjects.length > 0);
    setOtherSubjects(initialSubjects);
    setOtherClassGroups(initialGroups);
    setSharedValid(true);
  }, [live?.id]);

  // Sin materia adicional la grabación no le aparece a nadie de ese programa.
  const sharedError = () => {
    if (!sharedEnabled) return null;
    if (!otherSubjects.length) return 'Agrega al menos un programa con su materia, o desmarca la clase compartida.';
    if (!sharedValid) return 'Cada programa agregado necesita al menos una materia.';
    return null;
  };
  const warnShared = (message) =>
    toast({ title: message, status: 'warning', duration: 4000, isClosable: true });

  const handleDateChange = (date) => {
    setDateFilter(date);
  };
  const BasicInfoSchemaUpdate = Yup.object().shape({
    title: Yup.string().required('Requerido'),
    iframe_code: Yup.string().required('Requerido'),
    type: Yup.string().required('Requerido'),
  });
  const BasicInfoSchemaCreate = Yup.object().shape({
    title: Yup.string().required('Requerido'),
    hour: Yup.string().required('Requerido'),
    minutes: Yup.string().required('Requerido'),
    iframe_code: Yup.string().required('Requerido'),
    type: Yup.string().required('Requerido'),
  });

  function horas() {
    let diasV = [];
    for (let step = 5; diasV.length < 17; step++) {
      if (step <= 9) {
        diasV.push({
          value: `0${step}`,
          label: step,
        });
      } else {
        diasV.push({
          value: `${step}`,
          label: step,
        });
      }
    }

    return diasV;
  }
  const handleInsertClass = async (values, action) => {
    try {
      setLoading(true);

      if (!dateFilter) return window.alert('Debes completar los campos requeridos *');
      if (sharedError()) return warnShared(sharedError());

      let formatDate = dayjs(dateFilter).format(`YYYY-MM-DD`);

      function horas() {
        let hour = Number(values.hour) + 5;
        switch (hour) {
          case 25:
            hour = '01';
            break;

          case 26:
            hour = '02';
            break;

          case 27:
            hour = '03';
            break;
        }
        return hour;
      }
      let tiempo = `${horas()}:${values.minutes}`;
      if (tiempo === '24:30') {
        tiempo = '00:30';
        formatDate = dayjs(dateFilter).add(1, 'day').format('YYYY-MM-DD');
      } else if (values.hour >= 20) {
        formatDate = dayjs(dateFilter).add(1, 'day').format('YYYY-MM-DD');
      }

      const newDate = `${formatDate}T${tiempo}:00.000Z`;

      const { period, semester, ...rest } = values;

      let data = {
        ...rest,
        start_date: newDate,
        subject: searchParams.get('subject'),
        class_group: searchParams.get('group'),
        [searchParams.get('type')]: searchParams.get('program'),
        school: user?.school?.id || null,
      };

      if (period) data.period = period;
      if (semester) data.semester = semester;

      // Clase compartida: materias y grupos de otros programas.
      if (sharedEnabled && otherSubjects.length) data.other_subjects = otherSubjects;
      if (sharedEnabled && otherClassGroups.length) data.other_class_groups = otherClassGroups;

      await xhr.post(`/live-classes/`, { data: data });

      setReload(true);
      toast({
        title: 'La clase se creó correctamente',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });

      action.resetForm();
      // Que la siguiente clase no salga compartida por arrastre.
      setSharedEnabled(false);
      setOtherSubjects([]);
      setOtherClassGroups([]);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const deleteClass = async (values, action) => {
    try {
      setLoading(true);

      const response = await xhr.delete(`/live-classes/${live?.id}`);

      setReload(true);

      setIsOpen(false);
      toast({
        title: 'La clase se eliminó correctamente',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const updateClass = async (values, action) => {
    if (sharedError()) return warnShared(sharedError());
    try {
      setLoading(true);

      let formatDate = dayjs(live.start_date).format(`YYYY-MM-DD`);

      function horas() {
        let hour = Number(values.hour) + 5;
        switch (hour) {
          case 25:
            hour = '01';
            break;

          case 26:
            hour = '02';
            break;

          case 27:
            hour = '03';
            break;
        }
        return hour;
      }
      let tiempo = `${horas()}:${values.minutes}`;
      if (tiempo === '24:30') {
        tiempo = '00:30';
        formatDate = dayjs(live.start_date).add(1, 'day').format('YYYY-MM-DD');
      } else if (values.hour >= 20) {
        formatDate = dayjs(live.start_date).add(1, 'day').format('YYYY-MM-DD');
      }

      const newDate = `${formatDate}T${tiempo}:00.000Z`;

      await xhr.put(`/live-classes/${live?.id}`, {
        data: {
          title: values.title,
          semester: values.semester,
          iframe_code: values.iframe_code,
          type: values.type,
          period: values.period ? values.period : null,
          start_date: newDate,
          school: user?.school?.id || null,
          ...(canShare && {
            other_subjects: sharedEnabled ? otherSubjects : [],
            other_class_groups: sharedEnabled ? otherClassGroups : [],
          }),
        },
      });

      setReload(true);
      toast({
        title: 'La clase se actualizó correctamente',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Formik
        initialValues={{
          title: live?.title || title || '',
          hour: dayjs(live?.start_date).format('HH') || '',
          minutes: dayjs(live?.start_date).format('mm') || '',
          semester: live?.semester || searchParams.get('semester') || '',
          iframe_code: live?.iframe_code || '',
          type: live?.type || 'zoom',
          period: live?.period || searchParams.get('period') || '',
        }}
        validationSchema={Object.keys(live).length === 0 ? BasicInfoSchemaCreate : BasicInfoSchemaUpdate}
        onSubmit={Object.keys(live).length === 0 ? handleInsertClass : updateClass}
        enableReinitialize
      >
        {(data) => {
          return (
            <Form>
              <Grid gap={5}>
                <GridItem colSpan={6}>
                  <Box mb="5px">Inicio de la clase</Box>
                  <DatePicker date={dateFilter} placeholder="Fecha de la clase" onChange={handleDateChange} />
                </GridItem>

                <GridItem colSpan={3}>
                  <Box mb="5px">Hora</Box>
                  <Field name="hour" as={Select} placeholder="Hora">
                    {horas().map((el) => (
                      <>
                        <option value={el.value} key={el.value}>
                          {el.label}
                        </option>
                      </>
                    ))}
                  </Field>
                  <ErrorMessage name={'hour'}>
                    {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
                  </ErrorMessage>
                </GridItem>

                <GridItem colSpan={3}>
                  <Box mb="5px">Minutos</Box>
                  <Field name="minutes" as={Select} placeholder="Minuto">
                    <option value={'00'}>00</option>
                    <option value={'30'}>30</option>
                  </Field>
                  <ErrorMessage name={'minutes'}>
                    {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
                  </ErrorMessage>
                </GridItem>

                <GridItem colSpan={12}>
                  <Field name="title" label="Titulo" color="black" placeholder="Titulo" as={Input} />
                  <ErrorMessage name={'title'}>
                    {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
                  </ErrorMessage>
                </GridItem>

                <GridItem colSpan={12}>
                  <Field name="iframe_code" label={user?.school ? "Link de la clase" : "Iframe"} color="black" placeholder={user?.school ? "Link de la clase" : "Iframe"} as={Input} />
                  <ErrorMessage name={'iframe_code'}>
                    {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
                  </ErrorMessage>
                </GridItem>

                <GridItem colSpan={4}>
                  <Field name="type" as={Select} placeholder="Tipo" label="Tipo">
                    <option value="zoom">Zoom</option>
                    <option value="googlemeet">Google Meet</option>
                    <option value="clickmeeting">Click Meeting</option>
                  </Field>
                </GridItem>

                {!user?.school && (
                  <>
                    <GridItem colSpan={4}>
                      <Field name="period" placeholder="Periodo" as={Select}>
                        <option value="P1">Periodo 1</option>
                        <option value="P2">Periodo 2</option>
                        <option value="P3">Periodo 3</option>
                        <option value="P4">Periodo 4</option>
                      </Field>
                      <br />
                    </GridItem>
                    <GridItem colSpan={4}>
                      <Field name="semester" placeholder="Semestre" as={Select}>
                        {semester.map((el, index) => (
                          <option key={el.value} value={el.value}>
                            {el.label}
                          </option>
                        ))}
                      </Field>
                    </GridItem>
                  </>
                )}
              </Grid>

              {canShare && (
                <Box mt="16px">
                  <Checkbox
                    isChecked={sharedEnabled}
                    onChange={(e) => setSharedEnabled(e.target.checked)}
                    colorScheme="purple"
                  >
                    Esta clase es compartida con otros programas
                  </Checkbox>
                  {sharedEnabled && (
                    <Box mt="10px">
                      <SharedClassPicker
                        key={live?.id || 'new'}
                        currentProgramType={searchParams.get('type')}
                        currentProgramId={searchParams.get('program')}
                        initialSubjects={initialSubjects}
                        initialGroups={initialGroups}
                        onChange={({ other_subjects, other_class_groups, valid }) => {
                          setOtherSubjects(other_subjects);
                          setOtherClassGroups(other_class_groups);
                          setSharedValid(valid);
                        }}
                      />
                    </Box>
                  )}
                </Box>
              )}

              <br />

              <Box display="flex" justifyContent="space-between">
                <Button type="submit" colorScheme="#574feb" bg="#574feb" width="140px" isLoading={loading}>
                  {Object.keys(live).length === 0 ? 'Crear' : 'Actualizar'}
                </Button>
                {Object.keys(live).length > 0 ? (
                  <Button
                    onClick={() => {
                      const shared = (live?.other_subjects || []).length;
                      const r = window.confirm(
                        shared
                          ? `Esta clase es compartida con ${shared} materia(s) de otros programas. Si la eliminas, desaparece para todos. ¿Quieres eliminarla?`
                          : '¿Quiéres eliminar esta clase en vivo?'
                      );

                      if (r) deleteClass();
                    }}
                    colorScheme="red"
                    width="140px"
                    isLoading={loading}
                  >
                    Eliminar
                  </Button>
                ) : (
                  ''
                )}
              </Box>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
